import type { LogoType } from '../../types';

export const ourClients: LogoType[] = [
  {
    id: 'cbfa1ad4',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo1.png',
        name: 'logo1.png',
        alt: '',
        width: 299,
        height: 267
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '358ad4fd',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo2.png',
        name: 'logo2.png',
        alt: '',
        width: 300,
        height: 261
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'dc834017',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo3.png',
        name: 'logo3.png',
        alt: '',
        width: 297,
        height: 300
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '97b21c03',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo4.png',
        name: 'logo4.png',
        alt: '',
        width: 318,
        height: 299
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '68d6011d',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo5.png',
        name: 'logo5.png',
        alt: '',
        width: 228,
        height: 300
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '00f2b4cf',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo6.png',
        name: 'logo6.png',
        alt: '',
        width: 300,
        height: 237
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '8c87a6da',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo7.png',
        name: 'logo7.png',
        alt: '',
        width: 301,
        height: 299
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '8ef5daab',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo8.png',
        name: 'logo8.png',
        alt: '',
        width: 300,
        height: 300
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'ae063845',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo9.png',
        name: 'logo9.png',
        alt: '',
        width: 300,
        height: 171
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '64a57f9e',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo10.png',
        name: 'logo10.png',
        alt: '',
        width: 230,
        height: 298
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'c74dcc12',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo11.png',
        name: 'logo11.png',
        alt: '',
        width: 297,
        height: 260
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '38b9ae78',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo13.png',
        name: 'logo13.png',
        alt: '',
        width: 300,
        height: 180
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'd517b639',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo14.png',
        name: 'logo14.png',
        alt: '',
        width: 300,
        height: 140
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'df8c7dd1',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo15.png',
        name: 'logo15.png',
        alt: '',
        width: 299,
        height: 105
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '7da39f9a',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo16.png',
        name: 'logo16.png',
        alt: '',
        width: 299,
        height: 156
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
